<template>
	        <div>
			<div class="promotion-campaign-filters promotion-table-filters ad-d-flex ad-d-flex-between">
			  <div class="promotion-table-filters-left-part ad-d-flex ad-d-flex-start">
			     <div class="ad-d-flex">
				    <el-button size="small" type="primary" @click="CreateCampaign"  icon="el-icon-plus">新建广告组</el-button>
					<el-button size="small" @click="batchCampaign" icon="el-icon-edit" :disabled="this.sels.length===0">批量修改</el-button>
				 </div>
			  </div>
			</div>
			<el-table :data="list" border highlight-current-row v-loading="listLoading"  @selection-change="selsChange" style="width: 100%;">
			<el-table-column type="selection" width="55">
			</el-table-column>			
			<el-table-column label="广告组名称" align="left" width="200">
			  <template slot-scope="scope">
			    <el-link style="font-size:12px;" @click="lookAds(scope.row)" type="primary">{{scope.row.name}}</el-link>
			  </template>
			</el-table-column>			
			<el-table-column label="广告组状态" align="center" width="130">
			 <template slot-scope="scope">
			   <span v-if="scope.row.status=='CAMPAIGN_STATUS_ENABLE'"><i style="color:#4dd599;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>
			   <span v-else ><i style="color:#999;font-size:7px;margin-right:2px;" class="fa fa-circle"></i> {{scope.row.statusName}}</span>			 
			 </template>
			</el-table-column>
			<el-table-column prop="watch_num" label="组预算" align="center" min-width="80">
			 <template slot-scope="scope">
			    <span v-if="scope.row.budget_mode=='BUDGET_MODE_DAY'">{{scope.row.budget}}</span>
				<span v-else-if="scope.row.budget_mode=='BUDGET_MODE_INFINITE'">不限</span>
			 </template>
			</el-table-column>
			<el-table-column prop="report.cost" label="消耗(元)" width="100" sortable align="center">
			</el-table-column>			
			<el-table-column prop="report.show" sortable label="展示" width="100" align="center"></el-table-column>
			<el-table-column prop="report.click" sortable label="点击" width="100"  align="center"></el-table-column>
			<el-table-column prop="report.convert" sortable label="转化数" width="100" align="center"></el-table-column>
			<el-table-column prop="report.cpi" sortable label="CPI"  width="100" align="center"></el-table-column>
			<el-table-column prop="report.cpm" sortable  label="CPM" width="100" align="center"></el-table-column>
			<el-table-column prop="report.ctr"sortable  label="CTR(%)" width="100" align="center"></el-table-column>
			<el-table-column prop="report.cvr" sortable label="CVR(%)" width="100" align="center"></el-table-column>
            <el-table-column label="操作" align="center" width="100" fixed="right">
				<template slot-scope="scope">
					<el-button type="text" style="color:#2F88FF;"  plain size="mini" @click="handleEdit(scope.$index, scope.row)">修改</el-button>
					<el-button type="text" plain @click="copyCampaign(scope.row)" style="color:#6f9a8d;" size="mini">复制</el-button>			
				</template>
			</el-table-column>			
		</el-table>
		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-button type="success" @click="updateStatus('enable')" icon="el-icon-check" :disabled="this.sels.length===0" size="small">开启</el-button>
			<el-button type="warning" @click="updateStatus('disable')" icon="el-icon-video-pause" :disabled="this.sels.length===0" size="small">暂停</el-button>			
			<el-button type="danger" @click="updateStatus('delete')" icon="el-icon-delete" size="small" :disabled="this.sels.length===0">删除</el-button>
			<el-pagination layout="total,sizes,prev, pager, next" @current-change="handleCurrentChange" @size-change="handleSizeChange" :page-size="pagesize" :total="total" style="float:right;">
			</el-pagination>
		</el-col>
		<!--广告组-->
		 <el-dialog title="广告组编辑" width="35%" :visible.sync="dialogCampaignVisible">
				  <el-form :model="CampaignForm"  label-width="120px">
				    <el-form-item label="广告组名称">
					  <el-input size="small" v-model="CampaignForm.campaign_name"  autocomplete="off"></el-input>
					</el-form-item>
                    <el-form-item label="预算类型">
					  <el-radio-group size="small" v-model="CampaignForm.budget_mode">
						  <el-radio-button label="BUDGET_MODE_INFINITE">不限</el-radio-button>
						  <el-radio-button label="BUDGET_MODE_DAY">日预算</el-radio-button>			  
					  </el-radio-group>
					</el-form-item>					
					<el-form-item v-if="CampaignForm.budget_mode=='BUDGET_MODE_DAY'" label="日预算">
					  <el-input v-model="CampaignForm.budget" size="small" placeholder="日预算不少于1000元" autocomplete="off"></el-input>
					</el-form-item>			  
				  </el-form>
				  <div slot="footer" class="dialog-footer">
					<el-button @click="dialogCampaignVisible = false">取 消</el-button>
					<el-button type="primary" @click="EditCampagin" v-loading="editLoading">保 存</el-button>
				  </div>
			</el-dialog>
			<!--批量修改-->
			 <el-dialog title="广告组批量修改" width="35%" :visible.sync="dialogCampaignBatchVisible">					 
					<el-form :model="CampaignBatchForm" label-width="120px">
						<el-form-item label="预算类型">
						  <el-radio-group size="small" v-model="CampaignBatchForm.budget_mode">
							  <el-radio-button label="BUDGET_MODE_INFINITE">不限</el-radio-button>
							  <el-radio-button label="BUDGET_MODE_DAY">日预算</el-radio-button>			  
						  </el-radio-group>
						</el-form-item>					
						<el-form-item v-if="CampaignBatchForm.budget_mode=='BUDGET_MODE_DAY'" label="日预算">
						  <el-input v-model="CampaignBatchForm.budget" size="small" placeholder="日预算不少于1000元" autocomplete="off"></el-input>
						</el-form-item>			  
					  </el-form>
					  <div slot="footer" class="dialog-footer">
						<el-button @click="dialogCampaignBatchVisible = false">取 消</el-button>
						<el-button type="primary" @click="BatchEditCampagin" v-loading="editLoading">确 认</el-button>
					  </div>
			 </el-dialog>
		</div>
</template>
<script>
	import { getCampaignListPage,updateAdStatus,updateCampagin,updateBatchCampagin,AddCampagin } from '../../../api/api';
	export default {		
		props:{
		  PannelName: {
            type: String,
			default:''
		  }
		},
		watch:{
		  PannelName:{
			 handler(val, oldVal){
			   if( val=='CampaignPanel' )
			   {
			     this.getCampaign()
			   }
			 },
			 deep:true
		 }
		},
		data() {
			return {
				sels:[],
				total:0,
				page:1,
				dialogCampaignVisible:false,
				dialogCampaignBatchVisible:false,
				pagesize:10,
				listLoading:false,
				editLoading:false,
				visible:false,
				gridData:[],
				CampaignForm:{},
				CampaignBatchForm:{},
				list:[],				
			}
		},
		computed:{
		   advertiser_id(){
		     return this.$store.getters.getAdvertiserId
		   },
		   filtering(){
		     return this.$store.getters.getFiltering
		   }
		},
		methods: {
		    CreateCampaign(){
			  this.$router.push(`/create/toutiao/${this.advertiser_id}`)
			},
			batchCampaign(){
			 this.CampaignBatchForm ={}
			 this.dialogCampaignBatchVisible = true
			},
			lookAds(row){
				let params ={
				   type:'AdsPanel',
				   campaign_obj:row
				}
				this.$emit('updatePannel',params)
		    },
			copyCampaign(row)
			{
			  var num = Math.floor(Math.random()*90) + 10
			  let form = {
			    advertiser_id:row.advertiser_id,
                budget:row.budget,
                budget_mode:row.budget_mode,
                landing_type:row.landing_type,
                campaign_name:row.name+'_'+'副本'+num			
			  }
			  AddCampagin(form).then((res) => {				
				if( res.code==200 )
				{
				  this.$message.success('复制成功');					  
				  this.getCampaign()
				  this.$emit('updateCampaign')
				}else{
				  this.$message.error(res.message);return false
				}										
			});
			},
			EditCampagin(){
			  if(this.CampaignForm.campaign_name=="")
			  {
			   this.$message.error('请填写广告组名称');
			   return false
			  }
			  this.editLoading =true
			  updateCampagin(this.CampaignForm).then((res) => {
					this.$message.success('修改成功');
					this.editLoading = false
                    this.$emit('updateCampaign')					
					this.dialogCampaignVisible = false
					this.getCampaign()					
				});
			},
			BatchEditCampagin(){
			    let CampaignFormList = this.sels.map((item, i, arr) => {
					return {
					   campaign_id:item.id,
					   advertiser_id:item.advertiser_id,
					   modify_time:item.modify_time
					}
				})
				this.editLoading =true
				updateBatchCampagin({CampaignFormList:CampaignFormList,CampaignBatchForm:this.CampaignBatchForm}).then((res) => {
					this.$message.success('修改成功');
					this.editLoading = false
					this.sels =[]
                    this.$emit('updateCampaign')					
					this.dialogCampaignBatchVisible = false
					this.getCampaign()				
				});
			},
			handleEdit(index,row)
			{
			  let obj ={
			      campaign_name:row.name,
				  campaign_id:row.id,
				  budget_mode:row.budget_mode,
				  advertiser_id:row.advertiser_id,
				  modify_time:row.modify_time,
				  budget:row.budget
			  }
			  this.CampaignForm = obj;
			  this.dialogCampaignVisible = true
			},
			handleCurrentChange(val){
			  this.page = val
			  this.getCampaign()
			},
			handleSizeChange(val) {
			  this.pagesize = val
			  this.page = 1
			  this.getCampaign()
			},
			selsChange: function (sels) {
				this.sels = sels;
			},
			updateStatus(status){
			  let ids = this.sels.map((item, i, arr) => {
					return item.id
				})
			  let para = {
					type: 1,
					level:'campaign',
					advertiser_id: this.advertiser_id,
					status:status,
					ids:ids
				};
                updateAdStatus(para).then((res) => {
					this.$message.success('操作成功');										  
					  this.page=1
					  this.sels =[]
					  this.getCampaign()						
				});				
			},
			getCampaign(){
			  let para = {
					page: this.page,
					advertiser_id: this.advertiser_id,
					filtering:this.filtering,
					page_size:this.pagesize
				};
				this.listLoading = true;
				getCampaignListPage(para).then((res) => {
					this.total = res.data.page_info.total_number;
					this.list = res.data.list;
					this.listLoading = false;
				});
			}
		},
		mounted() {
			//this.getCampaign()	
		}
	}

</script>
<style  lang="scss">
  
</style>


// WEBPACK FOOTER //
// campaign.vue?15789b76